"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EventSourceBuilder_1 = __importDefault(require("./EventSourceBuilder"));
const ApiBuilder_1 = __importDefault(require("./ApiBuilder"));
const CustomMustacheFunctionsBuilder_1 = __importDefault(require("./CustomMustacheFunctionsBuilder"));
/**
 * Class for dynamic configurations, that can be init on client side
 * @field apiBuilder - can be used to provide custom axios instance, i.e with custom interceptors
 */
class CoreConfiguration {
    constructor(config) {
        var _a, _b, _c;
        this.apiBuilder = (_a = config === null || config === void 0 ? void 0 : config.apiBuilder) !== null && _a !== void 0 ? _a : ApiBuilder_1.default.getInstance();
        this.customMustacheFunctionsBuilder =
            (_b = config === null || config === void 0 ? void 0 : config.customMustacheFunctionsBuilder) !== null && _b !== void 0 ? _b : CustomMustacheFunctionsBuilder_1.default.getInstance({});
        this.sseBuilder =
            (_c = config === null || config === void 0 ? void 0 : config.sseBuilder) !== null && _c !== void 0 ? _c : EventSourceBuilder_1.default.getInstance((url, options) => new EventSource(url, options));
        this.appConfig = config === null || config === void 0 ? void 0 : config.appConfig;
    }
    /**
     * Get or init new CoreConfiguration instance
     * @param config ICoreConfiguration
     * @returns CoreConfiguration
     */
    static getInstance(config) {
        if (!CoreConfiguration.instance) {
            CoreConfiguration.instance = new CoreConfiguration(config);
        }
        return CoreConfiguration.instance;
    }
    get apiUrl() {
        return this.apiBuilder.apiUrl;
    }
    /**
     * Init new CoreConfiguration
     * @param config ICoreConfiguration
     */
    static init(config) {
        if (CoreConfiguration.instance) {
            throw Error('CoreConfiguration already initialized. Use CoreConfiguration.getInstance() instead');
        }
        CoreConfiguration.instance = new CoreConfiguration(config);
    }
}
exports.default = CoreConfiguration;
//# sourceMappingURL=CoreConfiguration.js.map